"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var nucleus_logging_1 = require("@cvent/nucleus-logging");
var MetricsContext_1 = require("../MetricsContext");
var sli_metrics_client_1 = require("@cvent/sli-metrics-client");
var PageActionsProvider_1 = require("./PageActionsProvider");
var storage_1 = require("./storage");
var LOG = new nucleus_logging_1.Logger('Metrics');
// Override default reporters with the extra options passed in Metrics configuration
var getReportersWithConfigOverrides = function (config, reporters) {
    return reporters.map(function (reporter) { return function (type, data, options) {
        var optionOverrides = __assign(__assign({}, options), { skipDeprecatedDefaultPrefix: config === null || config === void 0 ? void 0 : config.skipDeprecatedDefaultPrefix, muteDeprecatedTags: config === null || config === void 0 ? void 0 : config.muteDeprecatedTags });
        reporter(type, data, optionOverrides);
    }; });
};
/**
 * Function to check if the Metrics component was correctly initialized
 */
var getPageActionApiConfig = function (config, reporters, delegateLogsToReporters) {
    if (reporters === void 0) { reporters = []; }
    var EmptyPageLoadProvider = function (_a) {
        var children = _a.children;
        return children;
    };
    // Check configuration
    if (!config || !config.environmentName) {
        LOG.debug('Metrics configuration missing. You must provide `environmentName` and `metricsEnabled` in the config property');
        return { metricsReporters: [], PageActionsMetrics: EmptyPageLoadProvider };
    }
    var _a = config.environmentName, environmentName = _a === void 0 ? 'dev' : _a, metricsEnabled = config.metricsEnabled;
    var PageActionsMetrics = metricsEnabled ? PageActionsProvider_1.PageActionsProvider : EmptyPageLoadProvider;
    // Only use the reporters in a deployed environment and if the consumer app doesn't request them
    var metricsReporters = environmentName === 'dev' && !delegateLogsToReporters
        ? [sli_metrics_client_1.logReporter]
        : getReportersWithConfigOverrides(config, __spreadArray([], reporters, true));
    return { metricsReporters: metricsReporters, PageActionsMetrics: PageActionsMetrics };
};
/**
 * This Component configures metrics reporting for your application and should wrap your
 * application's entry point component (most likely under /pages/_app) to make the metrics
 * api available anywhere within the code. Out of the box it will give you a log reporter
 * used for development and in higher regions it will install the reporters provided during
 * initialization.
 *
 * @param props
 * {
 *   baseData: Record<string, string | {}>,
 *   config: {
 *     excludeUrls?: string[],
 *     excludedPaths?: string[],
 *     environmentName: string,
 *     metricsEnabled: boolean,
 *     skipDeprecatedDefaultPrefix?: boolean,
 *     muteDeprecatedTags?: boolean
 *   },
 *   children: React.ReactNode
 * }
 *
 */
var Metrics = function (_a) {
    var baseData = _a.baseData, config = _a.config, children = _a.children, _b = _a.reporters, reporters = _b === void 0 ? [] : _b, _c = _a.delegateLogsToReporters, delegateLogsToReporters = _c === void 0 ? false : _c, _d = _a.getPersistedDataCallback, getPersistedDataCallback = _d === void 0 ? storage_1.getPersistedData : _d, _e = _a.setPersistedDataCallback, setPersistedDataCallback = _e === void 0 ? storage_1.savePersistedData : _e;
    // check the configuration to see if we should add the default "cvent_" prefix to the attributes/properties of the
    // data object that is sent by reporters
    var prefix = (0, sli_metrics_client_1.shouldSkipDefaultPrefix)(config) ? '' : undefined;
    (0, sli_metrics_client_1.setDDViewCustomAttributes)(baseData, prefix);
    var _f = getPageActionApiConfig(config, reporters, delegateLogsToReporters), metricsReporters = _f.metricsReporters, PageActionsMetrics = _f.PageActionsMetrics;
    return (React.createElement(MetricsContext_1.MetricsProvider, { reporters: metricsReporters, baseData: baseData },
        React.createElement(PageActionsMetrics, { config: config, getPersistedDataCallback: getPersistedDataCallback, setPersistedDataCallback: setPersistedDataCallback }, children)));
};
exports.default = Metrics;
